import { render, staticRenderFns } from "./LineShop.vue?vue&type=template&id=b581bb3c&scoped=true&"
import script from "./LineShop.vue?vue&type=script&lang=js&"
export * from "./LineShop.vue?vue&type=script&lang=js&"
import style0 from "./LineShop.vue?vue&type=style&index=0&id=b581bb3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b581bb3c",
  null
  
)

export default component.exports